import styled from '@emotion/styled';
import React, {HTMLAttributes} from 'react';

import {mixinFlexboxColumn} from '@ELib/styles/mixins';

import {DisabledOverlay} from './DisabledOverlay';
import {ESplayCorner} from './ESplayCorner';

export interface DropAreaProps extends HTMLAttributes<HTMLElement> {
  isDragging: boolean;
  inactive?: boolean;
}

export const DropArea = ({
  children,
  isDragging,
  ...props
}: React.PropsWithChildren<DropAreaProps>): React.ReactElement => (
  <DropAreaWrapper className='DropArea' isDragging={isDragging} {...props}>
    {props.inactive ? <DisabledOverlay data-testid='disabled-overlay' /> : null}
    <SplayCorner
      data-testid='splay-corner'
      inactive={props.inactive}
      isDragging={isDragging}
    />
    {children}
  </DropAreaWrapper>
);

const DropAreaWrapper = styled.div<{
  isDragging: boolean;
  inactive?: boolean;
}>`
  position: relative;
  display: flex;
  padding: var(--gutter-big);
  justify-content: center;
  align-items: center;
  text-align: center;
  border: ${({isDragging, inactive}): string =>
    `var(--regular-border-width) ${inactive || isDragging ? 'solid' : 'dashed'} ${
      inactive
        ? 'var(--drop-area-inactive-border-color)'
        : 'var(--color-core-link)'
    }`};
  color: ${({inactive}): string =>
    inactive
      ? 'var(--drop-area-inactive-font-color)'
      : 'var(--color-core-black)'};
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-thin);
  ${({inactive}): string =>
    inactive ? 'pointer-events: none; user-select: none;' : 'cursor: pointer;'}
`;

const SplayCorner = styled(ESplayCorner)<{
  inactive?: boolean;
  isDragging?: boolean;
}>`
  :after {
    border-top: ${({isDragging, inactive}): string =>
      `var(--regular-border-width) ${inactive || isDragging ? 'solid' : 'dashed'} ${
        inactive
          ? 'var(--drop-area-inactive-border-color)'
          : 'var(--color-core-link)'
      }`};
  }
`;

export const DropAreaContent = styled.div`
  ${mixinFlexboxColumn}
  align-items: center;
`;
